import React from "react";

const LetterWritingIcon = () => {
  return (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 11.9986C3.34 11.9986 2 13.3386 2 14.9986C2 16.3086 0.84 16.9986 0 16.9986C0.92 18.2186 2.49 18.9986 4 18.9986C6.21 18.9986 8 17.2086 8 14.9986C8 13.3386 6.66 11.9986 5 11.9986ZM18.71 2.62859L17.37 1.28859C16.98 0.898594 16.35 0.898594 15.96 1.28859L7 10.2486L9.75 12.9986L18.71 4.03859C19.1 3.64859 19.1 3.01859 18.71 2.62859V2.62859Z"
        fill="#5E6572"
      />
    </svg>
  );
};

export default LetterWritingIcon;
